module.exports = __webpack_public_path__ + "img/vertical_4_5_8017.ddccebb7.png";